import { FuseNavigationItem } from '@fuse/components/navigation';
import { auditingNavigation } from './apps/auditing/auditing.navigation';
import { iamNavigation } from './apps/iam/iam.navigation';
import { oAuthNavigation } from './apps/o-auth/o-auth.navigation';
import { orionNavigation } from './apps/orion/orion.navigation';
import { queueManagerNavigation } from './apps/queue-manager/queue-manager.navigation';
import { toolsNavigation } from './apps/tools/tools.navigation';

export const adminNavigation: FuseNavigationItem[] = [
    orionNavigation,
    iamNavigation,
    oAuthNavigation,
    queueManagerNavigation,
    auditingNavigation,
    toolsNavigation,
];
